import styled from '@emotion/styled'
import MuiDialog from '@mui/material/Dialog'
import { tokens } from '../../theme.js'
const colors = tokens.colors
const borderRadius = tokens.borderRadius

export const Dialog = styled(MuiDialog, { shouldForwardProp: p => p !== 'theme' && p !== 'width' })`
  & .MuiBackdrop-root {
    background: ${colors.background.pageOverlay};
  }
  & .MuiPaper-root {
    border-radius: ${borderRadius.div};
    padding: 30px;
    width: ${p => p.width || 420}px;
    max-width: calc(100vw - 40px);
    box-shadow: none;
  }
`
export const WideDialog = styled(Dialog)`
  & .MuiPaper-root {
    width: calc(100vw - 32px);
    max-width: none;
    height: calc(100vh - 32px);
    max-height: none;
    margin: 16px;
    padding: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
`
export const Toggle = styled.div`
  display: inline-flex;
  flex: 0 0 auto;
  border: 1px solid ${colors.sectionDivider};
  border-radius: ${borderRadius.button};
  overflow: hidden;
  & > button {
    border: none;
    padding: 7px 16px;
    cursor: pointer;
    font: 500 13px/1.2 ${tokens.fonts.body};
    background: ${colors.white};
    color: ${colors.primary};
  }
  & > button + button {
    border-left: 1px solid ${colors.sectionDivider};
  }
  & > button:disabled {
    cursor: default;
    color: ${colors.text.muted};
    background: ${colors.background.light};
  }
  & > button[aria-pressed='true'] {
    background: ${colors.primary};
    color: ${colors.white};
  }
  & > button[aria-pressed='true'][data-tone='danger'] {
    background: ${colors.error};
    color: ${colors.white};
  }
`
export const DialogTitle = styled.h2`
  margin: 0 0 20px;
  font: 600 18px/1.4 ${tokens.fonts.heading};
  color: ${colors.text.heading};
`
export const DialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 24px;
`
